import React, { lazy } from 'react';
import { Container } from '../ui/Container';
import { TestimonialCard } from '../ui/TestimonialCard';
export const SocialProofSection: React.FC = () => {
  const testimonials = [{
    quote: "You guys are literally the [only marketers I've ever given a 10/10 to]... And we've worked with dozens of agencies over the years. We took a NEW offer from [ZERO to $3m in cumulative revenue within the 7-8 months] we were working on it...",
    author: 'Rian Doris',
    position: 'Consulting.com x Flow Research Collective',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oiaj5uFwDCbSWrBFJPCHby/Rian_Headshot.jpg',
    socialType: 'youtube',
    socialCount: '441K',
    socialLink: 'https://www.youtube.com/@riandoris/videos',
    showVerification: true
  }, {
    quote: "I've spent tons of money and tons of time working with other teams... and at the end of the day, I wasn't getting the lead that actually matched the avatar that I was looking to sell to. But working with DJ and Maciej was completely different. The leads that came to me were [EXACTLY the leads I was looking for], and it was a game changer for our business.",
    author: 'Ben Kelly',
    position: 'Acquisition Ace x Light House Capital Group',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1YxboSyP5rQL5MzLY2yrky/Ben_Headshot.jpg',
    socialType: 'instagram',
    socialCount: '550K',
    socialLink: 'https://www.instagram.com/benkellyone',
    showVerification: true
  }, {
    quote: "Their understanding of psychographics, psychology, marketing, and offer architecture is [nothing short of world class]. It's the kind of [surgical, sniper-like precision] you rarely encounter. If you're fortunate enough to work with them, [take their insight and implement it yesterday].",
    author: 'David Reineke',
    position: 'Aeon Financial Group x Arcian Holdings Limited',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8Cm3MhTVCK6K4nqqfG6wHw/Mastermind_Photo.jpg',
    socialType: 'twitter',
    socialCount: '75.4K',
    socialLink: 'https://x.com/yourealazyfvck',
    showVerification: true
  }, {
    quote: "We had a [$20,000 day]... a [$40,000 day]... they, did what no marketing agency could do, and that's [actually do what they said they were gonna do].",
    author: 'Zack Jenson',
    position: 'Tax Wise Financial Services x Accounting Ace',
    imageSrc: 'https://uploadthingy.s3.us-west-1.amazonaws.com/95qayCPmQquSF1XEQaRxXD/Zack_Headshot.jpg',
    showVerification: false
  }];
  return <section className="w-full bg-dark-800 py-24 relative" data-id="element-679">
      <div className="absolute inset-0 bg-gradient-to-b from-dark-600 to-dark-700 opacity-50" data-id="element-680" />
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-681" />
      <Container className="relative" data-id="element-682">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-683">
          {testimonials.slice(0, 4).map((testimonial, index) => <div key={index} className="bg-dark-600/50 backdrop-blur-sm rounded-2xl p-6 flex flex-col min-h-[500px]" data-id="element-684">
              <TestimonialCard quote={testimonial.quote} author={testimonial.author} position={testimonial.position} imageSrc={testimonial.imageSrc} socialType={testimonial.socialType} socialCount={testimonial.socialCount} socialLink={testimonial.socialLink} showVerification={testimonial.showVerification} className="text-sm sm:text-base lg:text-lg" data-id="element-685" />
            </div>)}
        </div>
      </Container>
    </section>;
};